import {gql, useQuery, useSubscription} from 'admin/lib/apollo'
import {useQueryParams, StringParam, NumberParam, withDefault} from 'use-query-params'
import {GET_PAYMENTS_PENDING} from '../gql/PaymentsPending.gql'

const SUBSCRIBE_TO_BANK_IMPORT_COMPLETED = gql`
  subscription SubscribeToBankImportCompleted {
    bankImportCompleted {
      id
    }
  }
`

export default () => {
  const [filters, setFilters] = useQueryParams({
    q: StringParam,
    fromDate: StringParam,
    toDate: StringParam,
    page: withDefault(NumberParam, 1),
    sortBy: withDefault(StringParam, 'payments.date'),
    sortDirection: withDefault(StringParam, 'desc')
  })

  const {data: {paymentsPending = {}} = {}, refetch} = useQuery(GET_PAYMENTS_PENDING, {variables: filters})

  useSubscription(SUBSCRIBE_TO_BANK_IMPORT_COMPLETED, {
    onData: () => refetch()
  })

  if (paymentsPending.metadata) {
    filters.limit = paymentsPending.metadata?.limitValue
  }

  return {
    filters,
    setFilters,
    imports: paymentsPending.collection || [],
    totalCount: paymentsPending.metadata?.totalCount || 0
  }
}
